import { ContextKind } from "../enums/ContextKind";

/** Key prefix of an instructor context (`instructor:<instructorId>`), as the server builds it. */
export const instructorContextKey = (instructorId: string): string => `instructor:${instructorId}`;

/** The locale key naming what the person is in a context: instructor, member or guardian. */
export const contextKindLabelKey = (context: { kind: ContextKind; wardCount: number }): string => {
  if (context.kind === ContextKind.Instructor) return "contexts.kind.instructor";
  return context.wardCount > 0 ? "contexts.kind.guardian" : "contexts.kind.member";
};

/** The given key first (the remembered context), the rest in the server's order. */
export const orderContexts = <T extends { key: string }>(contexts: T[], firstKey: string | null): T[] => {
  const first = contexts.find((context) => context.key === firstKey);
  return first ? [first, ...contexts.filter((context) => context !== first)] : contexts;
};
